export enum Angebotsart {
  UNFALL_AKTIV = "UNFALL_AKTIV",
  FREI = "FREI",
}
